export default __webpack_public_path__ + "d7b0df03ce234676ae8892d7bba46eb1.png";